import React from 'react';
import module_style from "../Style.module.css";
import Dots from '@material-ui/icons/DragIndicator';
import PropTypes from "prop-types";
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import EditIcon from '@material-ui/icons/Edit';
import { useDispatch, useSelector } from 'react-redux';
import { EXLY_WEBPAGE_DETAILS__SET_SELECTED_KEYWORD, EXLY_WEBPAGE_DETAILS__SET_SELECTED_SKU } from "ui/pages/TemplatePreview/redux/actions";
import { is_empty } from 'utils/validations';

const AccordianCard = ({ title, children, provided, handleEdit, item }) => {
    const dispatch = useDispatch();
    const selected_keyword = useSelector((state) => state.webpage_detail.selected_keyword);
    const selected_sku = useSelector((state) => state.webpage_detail.selected_sku);

    const [show_body, set_show_body] = React.useState(false);
    const [expand, set_expand] = React.useState(false);

    const handleChange = () => {
        let value = !expand;
        set_expand(value)
        if (value) {
            if (item?.sku) dispatch({ type: EXLY_WEBPAGE_DETAILS__SET_SELECTED_SKU, sku: item.sku });
            if (item?.uuid) dispatch({ type: EXLY_WEBPAGE_DETAILS__SET_SELECTED_KEYWORD, payload: item });
            set_show_body(true)
        }
        else {
            if (item?.sku) dispatch({ type: EXLY_WEBPAGE_DETAILS__SET_SELECTED_SKU, sku: null });
            if (item?.uuid) dispatch({ type: EXLY_WEBPAGE_DETAILS__SET_SELECTED_KEYWORD, payload: null });
            set_show_body(false)
        }
    }

    return (
        <Accordion expanded={expand} defaultExpanded={(!is_empty(selected_keyword?.uuid) && !is_empty(item?.uuid) && selected_keyword?.uuid === item?.uuid) || (!is_empty(selected_sku) && !is_empty(item?.sku) && selected_sku === item?.sku)} className={`${module_style.card} mb-4`}>
            <AccordionSummary>
                <div style={{ display: "flex", alignItems: "center", width: '100%' }}>
                    <div className={`mr-2`}><ExpandMoreIcon onClick={handleChange} /></div>
                    <div className={`${module_style.listing_info} ${module_style.min_width_title}`}><div>{title}</div></div>
                    {handleEdit && <div className="mr-1"><EditIcon onClick={(e) => {
                        e.preventDefault();
                        handleEdit();
                    }} /></div>}
                    {provided && <div className="mr-1" style={{ cursor: "grab" }} {...provided.dragHandleProps}><Dots /></div>}
                </div>
            </AccordionSummary>
            {show_body && children}
        </Accordion>
    )
}

AccordianCard.propTypes = {
    item: PropTypes.object,
    provided: PropTypes.object,
    title: PropTypes.string,
    children: PropTypes.element,
    handleEdit: PropTypes.func
};

export default AccordianCard;